export const ROUTE_CHECK_IN = '/checkIn';
